import React, { PropTypes } from "react"
import { connect } from "react-redux"
import axios from "axios"
import { Image, Media, Panel } from "react-bootstrap"
import { Row, Col } from "antd"
import Classnames from "classnames"
import Card, { CardHeader } from "../core/Card"

// SHARED
import { docCookies } from "../utils/docCookies"
import { potentialCreditsSuccess } from "./actions"

class PotentialCredits extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.initialState()

    const axiosConfig = {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      headers: {
        Authorization: docCookies.getItem("auth_token")
          ? "Token token=" + docCookies.getItem("auth_token")
          : "",
        "X-Api-Key": process.env.REACT_APP_X_API_KEY
      }
    }

    this.axiosClient = axios.create(axiosConfig)
  }

  initialState() {
    return {
      potential_credits: ""
    }
  }

  componentDidMount() {
    const { user } = this.props.models

    // Only get potential credits if user is not part of a group
    if (user && user.group_as_cobrand_member == null) {
      this.getPotentialCredits()
    }
  }

  componentWillReceiveProps(nextProps) {
    //this.getPotentialCredits();
  }

  getPotentialCredits() {
    let url =
      process.env.REACT_APP_API_BASE_URL + "subscriptions/potential_credits"
    // Check coupon with server
    this.axiosClient
      .get(url)
      .then(response => {
        let state = this.state

        if (response.status != 200) {
          // Erro
          console.log(response.data.error_message)

          this.setState(this.initialState())
        } else {
          // Success

          state["potential_credits"] = response.data.potential_credits
          this.setState(state)
          // alert(JSON.stringify(response.data))

          this.props.dispatch(potentialCreditsSuccess(response.data))
        }
      })
      .catch(err => {
        let state = this.state

        // Error
        console.log(err)
        this.setState(this.initialState())
      })
  }

  handleClick(e) {
    e.preventDefault()
    this.context.router.push({ pathname: "/premium" })
  }

  render() {
    // const { productIdentifier } = this.props
    const productIdentifier =
      (this.props.user.subscription &&
        this.props.user.subscription.product_identifier) ||
      ""

    let iSubscriptionYearly = false
    if (productIdentifier == "stripe.yearly.premium") {
      iSubscriptionYearly = true
    }

    let creditsCopy = ""
    let creditsCopyPresent = false
    // if (this.state.potential_credits > 0 && !iSubscriptionYearly) {

    creditsCopyPresent = true
    // }

    const potenitalCreditsClass = Classnames({
      "display-none": !creditsCopyPresent,
      "potential-credits-component": true,
      well: false,
      "cursor-pointer": true
    })

    const innerContent = (
      <div
        className={potenitalCreditsClass}
        onClick={this.handleClick.bind(this)}
      >
        <Row type="flex" justify="center" align="middle">
          <Col xs={24} sm={4}>
            <img
              width={25}
              height={25}
              src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/Gift+Filled-100.png"
              alt="rewards"
            />
          </Col>
          <Col xs={24} sm={20}>
            <h3>Claim your ${this.state.potential_credits} Reward</h3>
            <p>
              Hurray! You have ${this.state.potential_credits} credits waiting
              for you when you upgrade to the yearly plan.
            </p>
          </Col>
        </Row>
      </div>
    )

    if (this.state.potential_credits > 0 && !iSubscriptionYearly) {
      // wrap in card if on home
      return this.props.wrapInCard ? (
        <Card className="Credits">{innerContent}</Card>
      ) : (
        innerContent
      )
    } else {
      return null
    }
  }
}

PotentialCredits.propTypes = {
  productIdentifier: PropTypes.string.isRequired
}

PotentialCredits.contextTypes = {
  router: PropTypes.object.isRequired
}

export default connect(state => state)(PotentialCredits)



// WEBPACK FOOTER //
// ./src/subscriptions/PotentialCredits.js